import React from "react";
import CreateArticle from "./CreateArticle";
import { useParams } from "react-router";
function EditArticlePage() {

  const { aid } = useParams();
  console.log(aid);
  return (
    <>
      <CreateArticle editId={aid}></CreateArticle>
    </>
  );
}

export default EditArticlePage;
